import * as $ from "jquery";

export function initializeTabs(elmt: JQuery<HTMLElement>) {
    elmt.find('.tab-link').on('click', (evt) => {
        elmt.find('.tabs > div').css('display', 'none');

        const tab = $($(evt.currentTarget).attr('href'));
        tab.css('display', 'block');
        tab.find('.autofocus')?.focus();

        elmt.find('.tab-link').parent().removeClass('active');
        $(evt.currentTarget).parent().addClass('active');

        return false;
    });

    // The fake links just simulate a click on the real one. It has to be there of course, but that's the point right?
    elmt.find('.fake-tab-link').on('click', (evt) => {
        const href = $(evt.currentTarget).attr('href');
        $(`.tab-link[href="${href}"`).trigger('click');
    });
}
